import { render, staticRenderFns } from "./setUp.vue?vue&type=template&id=9f0c752c&scoped=true&"
import script from "./setUp.vue?vue&type=script&lang=js&"
export * from "./setUp.vue?vue&type=script&lang=js&"
import style0 from "./setUp.vue?vue&type=style&index=0&id=9f0c752c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0c752c",
  null
  
)

export default component.exports